import React, { useState } from "react";
import "./TermsAcceptance.css";

const TermsAcceptance = ({ onAccept, onCancel }) => {
  const [accepted, setAccepted] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const handleAccept = async () => {
    if (accepted && onAccept) {
      setIsProcessing(true);
      try {
        await onAccept();
      } catch (error) {
        console.error("Error in terms acceptance:", error);
      } finally {
        setIsProcessing(false);
      }
    }
  };

  return (
    <div className="terms-acceptance-overlay">
      <div className="terms-acceptance-modal">
        <div className="terms-header">
          <h2>Terms and Conditions</h2>
          <p>Please read and accept our terms and conditions to continue</p>
        </div>{" "}
        <div className="terms-content">
          <p className="terms-intro">
            By using our steam car wash services, you agree to the following
            terms and conditions:
          </p>

          <div className="terms-section">
            <h3>1. Personal Belongings</h3>
            <p>
              The management is not responsible for any loss or damage to
              personal items left inside the vehicle.
            </p>
            <p>
              Customers must ensure all valuables and belongings are removed
              before handing over the vehicle for service.
            </p>
          </div>

          <div className="terms-section">
            <h3>2. Customer Conduct</h3>
            <p>
              Customers agree to refrain from interacting with staff during the
              service to maintain safety and efficiency.
            </p>
          </div>

          <div className="terms-section">
            <h3>3. Payment Policy</h3>
            <p>
              Cash payments made directly to workers are strictly prohibited.
              The management is not liable for any disputes or issues resulting
              from such transactions.
            </p>
            <p>
              All payments are final and non-refundable. Please verify all
              service details before making a payment.
            </p>
          </div>

          <div className="terms-section">
            <h3>4. Paint Protection Film (PPF) Disclaimer</h3>
            <p>
              Customers confirm that their vehicle does not have Paint
              Protection Film (PPF).
            </p>
            <p>
              If PPF is applied, it is the customer's responsibility to obtain a
              written certification from their car service provider, confirming
              that the vehicle is safe for steam washing.
            </p>
          </div>

          <div className="terms-section">
            <h3>5. Liability Disclaimer</h3>
            <p>
              While every effort is made to provide a safe and damage-free
              service, Steam and Drive will not be held responsible for any
              pre-existing issues or conditions that may be affected by the
              steam cleaning process.
            </p>
          </div>
        </div>
        <div className="terms-actions">
          <div className="terms-checkbox">
            <label>
              <input
                type="checkbox"
                checked={accepted}
                onChange={(e) => setAccepted(e.target.checked)}
              />
              I have read and agree to the Terms and Conditions
            </label>
          </div>

          <div className="terms-buttons">
            <button
              type="button"
              onClick={onCancel}
              className="terms-cancel-btn"
            >
              Cancel
            </button>{" "}
            <button
              type="button"
              onClick={handleAccept}
              className={`terms-accept-btn ${
                accepted ? "enabled" : "disabled"
              }`}
              disabled={!accepted || isProcessing}
            >
              {isProcessing ? "Processing..." : "Accept & Continue"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAcceptance;
